export const SESSION_CATEGORY = {
  UPCOMING: 'upcoming',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export enum SessionFilterType {
  TYPE = 'Type',
  STUDENT = 'Student',
  SUBJECT = 'Subject',
}

export const SessionFilterTypeOption = {
  '1-on-1': 'Course',
  Masterclass: 'Classroom',
  Group: 'Group',
} as const;
